import { NotificationState } from './types'

/**
 * Main notification aggregator hook
 * This hook combines all notification types and provides them to the sidebar
 *
 * Usage in Sidebar:
 * const notifications = useNotifications(tenantId)
 *
 * To add a new notification type:
 * 1. Create a new hook in hooks/notifications/useXXXAlerts.ts
 * 2. Import and call it here
 * 3. Add it to the return object
 *
 * The training cycle renewal alert retired with the legacy trainings model,
 * so no source feeds the aggregator right now.
 */
export const useNotifications = (tenantId: string | undefined): NotificationState => {
  void tenantId

  return {}
}
